import React from "react";
import {
  Navbar,
  Collapse,
  Typography,
  IconButton,
} from "@material-tailwind/react";
import logo from "../assets/svgs/CiphersLogoWText.svg";

import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";

function NavList() {
  return (
    <ul className="my-2 flex flex-col gap-2 lg:mb-0 lg:mt-0 lg:flex-row lg:items-center lg:gap-6">
      <Typography
        as="li"
        variant="small"
        color="blue-gray"
        className="p-1 font-medium"
        title="contact@ciphers.me"
      >
        <a
          href="mailto:contact@ciphers.me"
          className="flex items-center hover:text-blue-500 transition-colors"
        >
          Mail us
        </a>
      </Typography>
      <Typography
        as="li"
        variant="small"
        color="blue-gray"
        className="p-1 font-medium"
      >
        <a
          href="/about"
          className="flex items-center hover:text-blue-500 transition-colors"
        >
          About us
        </a>
      </Typography>
      <Typography
        as="li"
        variant="small"
        color="blue-gray"
        className="p-1 font-medium"
      >
        <a
          href="https://b2b.Ciphers.me/"
          className="flex items-center hover:text-blue-500 transition-colors"
        >
          For postal organisations
        </a>
      </Typography>
    </ul>
  );
}

function Nav() {
  const [openNav, setOpenNav] = React.useState(false);

  const handleWindowResize = () =>
    window.innerWidth >= 960 && setOpenNav(false);

  React.useEffect(() => {
    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  return (
    <div className="w-full">
      <Navbar className="mx-auto my-auto w-full px-3 border-0 bg-[#402ea2] py-1">
        <div className="flex xl:flex-0 items-center xl:flex-row  justify-between text-blue-gray-900">
          <Typography
            variant="h6"
            className="mr-4  py-1.5  flex items-center"
          >
            <a href="/">
              <img src={logo} className="fill-white pr-4 " alt="logo" />
            </a>
            <p className="text-chipText cursor-default bg-chipSoon rounded-full w-[109px] flex justify-center text-sm font-semibold text-[13px]">
              Opening soon
            </p>
          </Typography>

          <div className=" ml-4 gap-4  flex justify-center "></div>
          <div className="hidden lg:block">
            <NavList />
          </div>
          <IconButton
            variant="text"
            className="text-inherit hover:bg-transparent focus:bg-transparent active:bg-transparent lg:hidden xl:hidden"
            ripple={false}
            onClick={() => setOpenNav(!openNav)}
          >
            {openNav ? (
              <XMarkIcon className="h-8" strokeWidth={2} />
            ) : (
              <Bars3Icon className="h-8" strokeWidth={2} />
            )}
          </IconButton>
        </div>
        <Collapse open={openNav}>
          <NavList />
        </Collapse>
      </Navbar>
    </div>
  );
}

export default Nav;